import FetchMediaObject from "@/@core/providers/fetch/fetchMediaObject";
import { stripDownloadSuffix } from "@/@core/utils/stripDownloadSuffix";

const GET = "get";
const POST = "post";

export default httpClient => {
  if (typeof httpClient === "string") {
    httpClient = new FetchMediaObject(httpClient);
  }

  return {
    [GET]: async (params = {}) => {
      const { imgId, requestSizes = [] } = params;
      let filterBuildQuery = "";

      if (requestSizes.length > 0) {
        filterBuildQuery = "?";
      }

      for (let i = 0; i < requestSizes.length; i++) {
        filterBuildQuery += `filter[]=${requestSizes[i]}&`;
      }

      const imgRequestPath = process.env.VUE_APP_API + stripDownloadSuffix(imgId) + filterBuildQuery;

      return await httpClient.get(imgRequestPath);
    },
    [POST]: (params = {}) => {
      const { file, generateSizes = [] } = params;

      let filterBuildQuery = "";
      if (generateSizes.length > 0) {
        filterBuildQuery = "?";
      }
      for (let i = 0; i < generateSizes.length; i++) {
        filterBuildQuery += `filter[]=${generateSizes[i]}&`;
      }

      const data = new FormData();
      data.append("file", file);

      const imgPostRequestPath = process.env.VUE_APP_API_URL + "/media_objects" + filterBuildQuery;

      return httpClient.post(imgPostRequestPath, data);
    },
  };
};
